import { escapeHtml, formatTimeAgo, getAvatarUrl } from '../../utils/helpers';
import BaseView from '../../common/base-view';

export default class HomeView extends BaseView {
  constructor() {
    super();
    this.eventHandlers = {};
    this.activeCameraStream = null;
    this.animationFrameId = null;
    this.cameraVideoElement = null;
    this.cameraCanvasElement = null;
    this.cameraCanvasContext = null;
    this.locationMap = null;
    this.locationMarker = null;
    this.searchTimeout = null;
    this.cameraDialogObserver = null;
    this.periodicIntervals = [];
    this.locationLayerItems = [];
  }

  async render() {
    return `
      <div id="page-home" class="page-content active">
          <section class="post-filter">
              <div class="filter-post">
                  <nav role="tablist" aria-label="Filter postingan">
                      <button class="active" type="button" id="all-post" data-text_tip="Semua postingan" data-hover_tip="bottom" data-dev_tip="desktop" role="tab" aria-selected="true" aria-controls="posts-container">
                          <span>Untuk Anda</span>
                      </button>
                      <button type="button" id="maps-only" data-text_tip="Postingan dengan lokasi" data-hover_tip="bottom" data-dev_tip="desktop" role="tab" aria-selected="false" aria-controls="posts-container">
                          <span>Dengan Lokasi</span>
                      </button>
                  </nav>
              </div>
              <div class="new-post-tab" id="new-post-tab">
                  <button type="button" class="show-new-posts" id="show-new-posts" data-text_tip="Lihat postingan terbaru" data-hover_tip="bottom" data-dev_tip="desktop">
                      <div class="user-post-recent" aria-label="Foto pengguna dengan postingan baru">
                          <div class="photos-recent">
                              <img src="${getAvatarUrl('User1')}" alt="User" width="24" height="24" loading="lazy">
                          </div>
                          <div class="photos-recent">
                              <img src="${getAvatarUrl('User2')}" alt="User" width="24" height="24" loading="lazy">
                          </div>
                          <div class="photos-recent">
                              <img src="${getAvatarUrl('User3')}" alt="User" width="24" height="24" loading="lazy">
                          </div>
                      </div>
                      <p>Lihat <span id="new-posts-count">25+</span> post terbaru</p>
                  </button>
              </div>
          </section>

          <section class="create-wrapper" aria-labelledby="create-post-title">
              <h2 id="create-post-title" class="sr-only">Buat Postingan Baru</h2>
              <form class="create-post" id="create-post-form">
                  <div class="wysiywg-wrapper">
                      <label for="wysiwyg-post" class="sr-only">Tulis postingan Anda</label>
                      <textarea class="wysiwyg" id="wysiwyg-post" placeholder="Apa yang Anda pikirkan?" aria-label="Tulis postingan Anda" rows="3"></textarea>
                  </div>
                  <div class="attachment-added">
                      <button type="submit" class="post-submit" id="submit-post" disabled data-text_tip="Kirim postingan" data-hover_tip="left" data-dev_tip="desktop">
                          <p>Kirim</p>
                          <span class="material-symbols-rounded" aria-hidden="true">send</span>
                      </button>

                      <div class="attachment">
                          <div class="image-added" id="image-preview">
                              <button type="button" class="remove-image" data-text_tip="Hapus gambar" data-hover_tip="left" data-dev_tip="desktop" aria-label="Hapus gambar">
                                  <span class="material-symbols-rounded" aria-hidden="true">close</span>
                              </button>
                              <div class="image-ov-hidden">
                                  <img src="" alt="Preview gambar" loading="lazy">
                              </div>
                          </div>
                          <div class="maps-added" id="location-preview" data-lat="" data-lon="">
                              <div class="nama-daerah">
                                  <p></p>
                              </div>
                              <button type="button" class="remove-location" data-text_tip="Hapus lokasi" data-hover_tip="left" data-dev_tip="desktop" aria-label="Hapus lokasi">
                                  <span class="material-symbols-rounded" aria-hidden="true">close</span>
                              </button>
                          </div>
                      </div>
                  </div>
              </form>
              <div class="attachment-form">
                  <div class="attachment-form-wrapper">
                      <button class="file-attach" type="button" id="add-image-btn" data-text_tip="Unggah foto" data-hover_tip="top" data-dev_tip="desktop">
                          <span class="material-symbols-rounded" aria-hidden="true">imagesmode</span>
                          <p>Tambah foto</p>
                      </button>
                  </div>
                  <div class="attachment-form-wrapper">
                      <button class="location-attach" type="button" id="add-location-btn" data-text_tip="Tambah lokasi" data-hover_tip="top" data-dev_tip="desktop">
                          <span class="material-symbols-rounded" aria-hidden="true">location_on</span>
                          <p>Lokasi</p>
                      </button>
                  </div>
              </div>
          </section>

          <section class="post-wrapper" aria-labelledby="posts-title">
              <h2 id="posts-title" class="sr-only">Daftar Postingan</h2>
              <div class="post-list" id="posts-container" role="tabpanel">
                  <div class="loading-post">
                      <div class="hg-animate" aria-hidden="true"></div>
                      <p>Memuat postingan...</p>
                  </div>
              </div>
          </section>
      </div>
    `;
  }

  async afterRender() {
    // Setup handled by presenter
  }

  setupFormEventListeners(onTextareaInput, onFormSubmit, onAddImage, onAddLocation, onRemoveImage, onRemoveLocation) {
    const textarea = document.querySelector('#wysiwyg-post');
    if (textarea) {
      this.eventHandlers.textareaHandler = onTextareaInput;
      textarea.addEventListener('input', this.eventHandlers.textareaHandler);
    }

    const form = document.querySelector('#create-post-form');
    if (form) {
      this.eventHandlers.formHandler = (e) => {
        e.preventDefault();
        onFormSubmit();
      };
      form.addEventListener('submit', this.eventHandlers.formHandler);
    }

    const submitBtn = document.querySelector('#submit-post');
    if (submitBtn) {
      this.eventHandlers.submitHandler = (e) => {
        e.preventDefault();
        onFormSubmit();
      };
      submitBtn.addEventListener('click', this.eventHandlers.submitHandler);
    }

    const addImageBtn = document.querySelector('#add-image-btn');
    if (addImageBtn) {
      this.eventHandlers.addImageHandler = onAddImage;
      addImageBtn.addEventListener('click', this.eventHandlers.addImageHandler);
    }

    const addLocationBtn = document.querySelector('#add-location-btn');
    if (addLocationBtn) {
      this.eventHandlers.addLocationHandler = onAddLocation;
      addLocationBtn.addEventListener('click', this.eventHandlers.addLocationHandler);
    }

    const removeImageButtons = document.querySelectorAll('.remove-image');
    this.eventHandlers.removeImageHandlers = [];
    removeImageButtons.forEach(btn => {
      const handler = onRemoveImage;
      btn.addEventListener('click', handler);
      this.eventHandlers.removeImageHandlers.push({ element: btn, handler });
    });

    const removeLocationButtons = document.querySelectorAll('.remove-location');
    this.eventHandlers.removeLocationHandlers = [];
    removeLocationButtons.forEach(btn => {
      const handler = onRemoveLocation;
      btn.addEventListener('click', handler);
      this.eventHandlers.removeLocationHandlers.push({ element: btn, handler });
    });
  }

  setupImageDialogEventListeners(onSelectImage, onImageChange, onSelectCamera, onCaptureImage, onFlipCamera, onCancelCamera) {
    const selectImageBtn = document.querySelector('#select-image');
    const imageInput = document.querySelector('#image-input');
    const selectCameraBtn = document.querySelector('#select-camera');
    
    if (selectImageBtn && imageInput) {
      this.eventHandlers.selectImageHandler = onSelectImage;
      this.eventHandlers.imageInputHandler = (e) => onImageChange(e.target.files[0]);
      
      selectImageBtn.addEventListener('click', this.eventHandlers.selectImageHandler);
      imageInput.addEventListener('change', this.eventHandlers.imageInputHandler);
    }
    
    if (selectCameraBtn) {
      this.eventHandlers.selectCameraHandler = onSelectCamera;
      selectCameraBtn.addEventListener('click', this.eventHandlers.selectCameraHandler);
    }
    
    const captureBtn = document.querySelector('#capture-from-canvas-btn');
    const flipBtn = document.querySelector('#flip-camera-btn');
    const cancelBtn = document.querySelector('#cancel-canvas-camera');
    
    if (captureBtn) {
      this.eventHandlers.captureHandler = onCaptureImage;
      captureBtn.addEventListener('click', this.eventHandlers.captureHandler);
    }
    
    if (flipBtn) {
      this.eventHandlers.flipHandler = onFlipCamera;
      flipBtn.addEventListener('click', this.eventHandlers.flipHandler);
    }
    
    if (cancelBtn) {
      this.eventHandlers.cancelHandler = onCancelCamera;
      cancelBtn.addEventListener('click', this.eventHandlers.cancelHandler);
    }
  }

  setupLocationDialogEventListeners(onCurrentLocation, onSaveLocation, onSearchLocation) {
    const currentLocationBtn = document.querySelector('#current-location');
    const saveLocationBtn = document.querySelector('#save-location');
    const searchInput = document.querySelector('#location-search');
    
    if (currentLocationBtn) {
      this.eventHandlers.currentLocationHandler = onCurrentLocation;
      currentLocationBtn.addEventListener('click', this.eventHandlers.currentLocationHandler);
    }
    
    if (saveLocationBtn) {
      this.eventHandlers.saveLocationHandler = onSaveLocation;
      saveLocationBtn.addEventListener('click', this.eventHandlers.saveLocationHandler);
    }
    
    if (searchInput) {
      this.eventHandlers.searchLocationHandler = (e) => onSearchLocation(e.target.value);
      searchInput.addEventListener('input', this.eventHandlers.searchLocationHandler);
    }
  }

  setupFilterEventListeners(onAllPost, onMapsOnly) {
    const allPostBtn = document.querySelector('#all-post');
    const mapsOnlyBtn = document.querySelector('#maps-only');

    if (allPostBtn) {
      this.eventHandlers.allPostHandler = (e) => {
        e.preventDefault();
        onAllPost();
      };
      allPostBtn.addEventListener('click', this.eventHandlers.allPostHandler);
    }
    
    if (mapsOnlyBtn) {
      this.eventHandlers.mapsOnlyHandler = (e) => {
        e.preventDefault();
        onMapsOnly();
      };
      mapsOnlyBtn.addEventListener('click', this.eventHandlers.mapsOnlyHandler);
    }
  }

  setupShowNewPostsEventListener(onShowNewPosts) {
    const showNewPostsBtn = document.querySelector('#show-new-posts');
    if (showNewPostsBtn) {
      this.eventHandlers.showNewPostsHandler = onShowNewPosts;
      showNewPostsBtn.addEventListener('click', this.eventHandlers.showNewPostsHandler);
    }
  }

  setupPostInteractionEventListeners(onBookmark, onShare, onImageClick, onNavigateToPost) {
    this.eventHandlers.globalClickHandler = (e) => {
      const bookmarkBtn = e.target.closest('.bookmark-this');
      if (bookmarkBtn) {
        e.stopPropagation();
        const storyId = bookmarkBtn.dataset.storyId;
        onBookmark(storyId);
        return;
      }

      const shareBtn = e.target.closest('.share-this');
      if (shareBtn) {
        e.stopPropagation();
        const storyId = shareBtn.dataset.storyId;
        onShare(storyId);
        return;
      }

      const postImage = e.target.closest('.post-image img');
      if (postImage) {
        e.stopPropagation();
        onImageClick(postImage.src);
        return;
      }

      const postArticle = e.target.closest('article.postingan');
      if (
        postArticle &&
        !e.target.closest(
          '.action-post, .post-image, .box-mini-maps, .bookmark-this, .share-this'
        ) &&
        !postArticle.closest('#single-post-container')
      ) {
        const storyId = postArticle.dataset.storyId;
        if (storyId && typeof onNavigateToPost === 'function') {
          onNavigateToPost(storyId);
        }
      }
    };
    
    document.addEventListener('click', this.eventHandlers.globalClickHandler);
  }

  setupInfiniteScrollEventListener(onScroll) {
    this.eventHandlers.scrollHandler = onScroll;
    window.addEventListener('scroll', this.eventHandlers.scrollHandler);
  }

  setupCameraDialogObserver(onDialogStateChange) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const dialog = mutation.target;
          const isOpen = dialog.classList.contains('show');
          onDialogStateChange(isOpen);
        }
      });
    });

    const cameraDialog = document.querySelector('#camera-canvas-dialog');
    if (cameraDialog) {
      observer.observe(cameraDialog, { attributes: true, attributeFilter: ['class'] });
      this.cameraDialogObserver = observer;
    }
  }

  setupPeriodicTimestampUpdates() {
    const interval = setInterval(() => {
      this.updateTimestamps();
    }, 60000);
    this.periodicIntervals.push(interval);
  }

  cleanupEventListeners() {
    const textarea = document.querySelector('#wysiwyg-post');
    if (textarea && this.eventHandlers.textareaHandler) {
      textarea.removeEventListener('input', this.eventHandlers.textareaHandler);
    }

    const form = document.querySelector('#create-post-form');
    if (form && this.eventHandlers.formHandler) {
      form.removeEventListener('submit', this.eventHandlers.formHandler);
    }

    const submitBtn = document.querySelector('#submit-post');
    if (submitBtn && this.eventHandlers.submitHandler) {
      submitBtn.removeEventListener('click', this.eventHandlers.submitHandler);
    }

    const addImageBtn = document.querySelector('#add-image-btn');
    if (addImageBtn && this.eventHandlers.addImageHandler) {
      addImageBtn.removeEventListener('click', this.eventHandlers.addImageHandler);
    }

    const addLocationBtn = document.querySelector('#add-location-btn');
    if (addLocationBtn && this.eventHandlers.addLocationHandler) {
      addLocationBtn.removeEventListener('click', this.eventHandlers.addLocationHandler);
    }

    const allPostBtn = document.querySelector('#all-post');
    if (allPostBtn && this.eventHandlers.allPostHandler) {
      allPostBtn.removeEventListener('click', this.eventHandlers.allPostHandler);
    }

    const mapsOnlyBtn = document.querySelector('#maps-only');
    if (mapsOnlyBtn && this.eventHandlers.mapsOnlyHandler) {
      mapsOnlyBtn.removeEventListener('click', this.eventHandlers.mapsOnlyHandler);
    }

    const showNewPostsBtn = document.querySelector('#show-new-posts');
    if (showNewPostsBtn && this.eventHandlers.showNewPostsHandler) {
      showNewPostsBtn.removeEventListener('click', this.eventHandlers.showNewPostsHandler);
    }

    if (this.eventHandlers.globalClickHandler) {
      document.removeEventListener('click', this.eventHandlers.globalClickHandler);
    }

    if (this.eventHandlers.scrollHandler) {
      window.removeEventListener('scroll', this.eventHandlers.scrollHandler);
    }

    if (this.eventHandlers.removeImageHandlers) {
      this.eventHandlers.removeImageHandlers.forEach(({ element, handler }) => {
        element.removeEventListener('click', handler);
      });
      this.eventHandlers.removeImageHandlers = [];
    }

    if (this.eventHandlers.removeLocationHandlers) {
      this.eventHandlers.removeLocationHandlers.forEach(({ element, handler }) => {
        element.removeEventListener('click', handler);
      });
      this.eventHandlers.removeLocationHandlers = [];
    }

    this.eventHandlers = {};
  }

  cleanupPeriodicUpdates() {
    this.periodicIntervals.forEach(interval => {
      clearInterval(interval);
    });
    this.periodicIntervals = [];
  }

  isPageActive() {
    const homePage = document.querySelector('#page-home.active');
    return homePage !== null;
  }

  isDarkMode() {
    return document.body.classList.contains('dark');
  }

  scrollToTop() {
    if (window.scrollY === 0) return;
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  }

  getScrollData() {
    return {
      documentHeight: document.documentElement.scrollHeight,
      windowHeight: window.innerHeight,
      scrollTop: window.scrollY
    };
  }

  getCameraElements() {
    return {
      video: document.getElementById('camera-video-source'),
      canvas: document.getElementById('camera-canvas-preview')
    };
  }

  getCameraDialogWidth() {
    const cameraCanvasElement = document.getElementById('camera-canvas-preview');
    return cameraCanvasElement ? cameraCanvasElement.parentElement.offsetWidth : 0;
  }

  isCameraDialogOpen() {
    const dialog = document.querySelector('#camera-canvas-dialog');
    return dialog && dialog.classList.contains('show');
  }

  initCameraStream(stream, onVideoReady) {
    const cameraElements = this.getCameraElements();
    if (!cameraElements.video || !cameraElements.canvas) {
      throw new Error('Elemen kamera tidak ditemukan dalam dialog');
    }

    
    this.cameraVideoElement = cameraElements.video;
    this.cameraCanvasElement = cameraElements.canvas;
    this.cameraCanvasContext = this.cameraCanvasElement.getContext('2d');

    this.activeCameraStream = stream;
    this.cameraVideoElement.srcObject = stream;
    
    this.cameraVideoElement.onloadedmetadata = () => {
      const videoWidth = this.cameraVideoElement.videoWidth;
      const videoHeight = this.cameraVideoElement.videoHeight;
      
      this.cameraVideoElement.width = videoWidth;
      this.cameraVideoElement.height = videoHeight;

      const dialogContentWidth = this.getCameraDialogWidth();
      this.cameraCanvasElement.width = dialogContentWidth;
      this.cameraCanvasElement.height = (videoHeight / videoWidth) * dialogContentWidth;
      
      this.cameraVideoElement.play();
      this.startDrawingFrames();
      onVideoReady();
    };
  }

  startDrawingFrames() {
    const drawFrame = () => {
        if (!this.activeCameraStream || !this.cameraVideoElement || !this.cameraCanvasElement || !this.cameraCanvasContext) {
          this.stopCameraStream();
          return;
        }
      
      if (this.cameraVideoElement.readyState >= this.cameraVideoElement.HAVE_CURRENT_DATA) {
        this.cameraCanvasContext.drawImage(
          this.cameraVideoElement, 
          0, 0, 
          this.cameraCanvasElement.width, 
          this.cameraCanvasElement.height
        );
      }
      
      this.animationFrameId = requestAnimationFrame(drawFrame);
    };
    
    drawFrame();
  }

  stopCameraStream() {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }

    const stream = this.activeCameraStream ||
      (this.cameraVideoElement ? this.cameraVideoElement.srcObject : null);

    if (stream) {
      stream.getTracks().forEach((t) => {
        try {
          t.stop();
        } catch (e) {
          /* ignore */
        }
      });
      this.activeCameraStream = null;
    }

    if (this.cameraVideoElement) {
      this.cameraVideoElement.pause();
      this.cameraVideoElement.srcObject = null;
    }

    this.clearCanvasCamera();
  }

  clearCanvasCamera() {
    const cameraCanvasElement = document.getElementById('camera-canvas-preview');
    if (cameraCanvasElement) {
      const context = cameraCanvasElement.getContext('2d');
      if (context) {
        context.clearRect(0, 0, cameraCanvasElement.width, cameraCanvasElement.height);
        // Set background abu-abu dengan teks
        context.fillStyle = '#333';
        context.fillRect(0, 0, cameraCanvasElement.width, cameraCanvasElement.height);
        context.fillStyle = '#fff';
        context.textAlign = 'center';
        context.font = '16px Arial';
        context.fillText('Kamera dinonaktifkan', cameraCanvasElement.width / 2, cameraCanvasElement.height / 2);
      }
    }
  }

  captureImageFromCanvas() {
    if (!this.cameraCanvasElement) {
      throw new Error('Canvas tidak siap');
    }
    
    if (this.cameraCanvasElement.width === 0 || this.cameraCanvasElement.height === 0) {
      throw new Error('Ukuran canvas tidak valid');
    }

    return new Promise((resolve, reject) => {
      this.cameraCanvasElement.toBlob((blob) => {
        if (blob) {
          const fileName = `camera_${Date.now()}.jpg`;
          const imageFile = new File([blob], fileName, { type: 'image/jpeg' });
          resolve(imageFile);
        } else {
          reject(new Error('Gagal membuat data gambar dari kamera'));
        }
      }, 'image/jpeg', 0.9);
    });
  }

  clearImageInput() {
    const imageInput = document.querySelector('#image-input');
    if (imageInput) {
      imageInput.value = '';
    }
  }

  triggerImageInput() {
    const imageInput = document.querySelector('#image-input');
    if (imageInput) {
      imageInput.click();
    }
  }

  clearLocationResults() {
    const resultsContainer = document.querySelector('#location-results');
    if (resultsContainer) {
      resultsContainer.remove();
    }
  }

  showLocationResults(features, onLocationSelect) {
    this.clearLocationResults();
    
    if (!features || features.length === 0) return;
    
    const searchInput = document.querySelector('#location-search');
    if (!searchInput) return;
    
    const resultsContainer = document.createElement('div');
    resultsContainer.id = 'location-results';
    resultsContainer.style.cssText = 'position: absolute; z-index: 1000; background: var(--bg-container); max-height: 200px; overflow-y: auto; border: 1px solid var(--border-color); border-radius: var(--radius-s); margin-top: 0.5rem; width: 100%;';
    
    let resultsHtml = '';
    features.forEach(feature => {
      const [lon, lat] = feature.center;
      resultsHtml += `
        <div class="location-result" data-lat="${lat}" data-lon="${lon}" style="padding: 0.75rem; cursor: pointer; border-bottom: 1px solid var(--border-color); color: var(--text-primary);">
          <strong>${feature.place_name}</strong>
        </div>
      `;
    });
    
    resultsContainer.innerHTML = resultsHtml;
    searchInput.parentNode.appendChild(resultsContainer);
    
    resultsContainer.addEventListener('click', (e) => {
      const resultEl = e.target.closest('.location-result');
      if (!resultEl) return;

      const lat = parseFloat(resultEl.dataset.lat);
      const lon = parseFloat(resultEl.dataset.lon);
      const placeName = resultEl.querySelector('strong').textContent;
      
      onLocationSelect(lat, lon, placeName);
    });
    
    return resultsContainer;
  }

  setLocationSearchValue(value) {
    const searchInput = document.querySelector('#location-search');
    if (searchInput) {
      searchInput.value = value;
    }
  }

  createLayerControl(selectedLayer = 'streets') {
    const view = this;
    this.locationLayerItems = [];
    
    class LayerControl {
      onAdd(map) {
        this._map = map;
        this._container = document.createElement('div');
        this._container.className = 'maplibregl-ctrl maplibregl-ctrl-group';
        
        const button = document.createElement('button');
        button.className = 'maplibregl-ctrl-icon';
        button.type = 'button';
        button.innerHTML = '<span class="material-symbols-rounded">layers</span>';
        button.title = 'Ubah layer peta';
        
        const dropdown = document.createElement('div');
        dropdown.className = 'layer-dropdown';
        dropdown.style.cssText = 'position: absolute; top: 100%; left: 0; background: var(--bg-container); border: 1px solid var(--border-color); border-radius: 4px; display: none; min-width: 120px; box-shadow: 0 2px 4px rgba(0,0,0,0.2);';
        
        const layers = [
          { name: 'Streets', value: 'streets' },
          { name: 'Satellite', value: 'satellite' },
          { name: 'Terrain', value: 'terrain' }
        ];
        
        layers.forEach(layer => {
          const item = document.createElement('div');
          item.textContent = layer.name;
          item.className = 'layer-list';
          item.dataset.layer = layer.value;
          item.style.cssText = 'padding: 8px 12px; cursor: pointer; color: var(--text-primary);';
          if (layer.value === selectedLayer) item.classList.add('active');
          item.addEventListener('click', () => {
            if (view.onLayerChange) {
              view.onLayerChange(layer.value);
            }
            dropdown.style.display = 'none';
          });
          dropdown.appendChild(item);
          view.locationLayerItems.push(item);
        });
        
        button.addEventListener('click', (e) => {
          e.stopPropagation();
          dropdown.style.display = dropdown.style.display === 'none' ? 'block' : 'none';
        });
        
        document.addEventListener('click', () => {
          dropdown.style.display = 'none';
        });
        
        this._container.appendChild(button);
        this._container.appendChild(dropdown);
        return this._container;
      }
      
      onRemove() {
        if (this._container && this._container.parentNode) {
          this._container.parentNode.removeChild(this._container);
        }
        this._map = undefined;
      }
    }
    
    return new LayerControl();
  }

  switchMapLayer(layerType, getStyleUrl) {
    if (this.locationMap && getStyleUrl) {
      const styleUrl = getStyleUrl(this.isDarkMode(), layerType);
      this.locationMap.setStyle(styleUrl);
    }
  }

  initLocationMap(config, onMapClick, selectedLayer = 'streets') {
    try {
      this.locationMap = new maplibregl.Map(config);
      this.locationMap.addControl(new maplibregl.NavigationControl(), 'top-right');

      const layerControl = this.createLayerControl(selectedLayer);
      this.locationMap.addControl(layerControl, 'top-left');
      
      this.locationMap.on('click', (e) => {
        const { lng, lat } = e.lngLat;
        this.addLocationMarker(lng, lat);
        onMapClick(lat, lng);
      });

      return this.locationMap;
    } catch (error) {
      throw new Error('Gagal init lokasi map: ' + error.message);
    }
  }

  setMapStyle(styleUrl) {
    if (this.locationMap) {
      this.locationMap.setStyle(styleUrl);
    }
  }

  setupMapLayerSwitch(onLayerChange) {
    this.onLayerChange = onLayerChange;
  }

  updateLayerSelection(layerType) {
    if (this.locationLayerItems) {
      this.locationLayerItems.forEach(el => {
        el.classList.toggle('active', el.dataset.layer === layerType);
      });
    }
  }

  addLocationMarker(lon, lat) {
    if (this.locationMarker) {
      this.locationMarker.remove();
    }
    
    this.locationMarker = new maplibregl.Marker({ color: '#B84C28' })
      .setLngLat([lon, lat])
      .addTo(this.locationMap);
  }

  setMapCenter(lon, lat, zoom = 13) {
    if (this.locationMap) {
      this.locationMap.setCenter([lon, lat]);
      this.locationMap.setZoom(zoom);
    }
  }

  showLoading(container) {
    super.showLoading(container);
  }

  showEmptyState(container, message) {
    super.showEmptyState(container, message);
  }

  showAuthRequired(container, onLoginClick) {
    super.showAuthRequired(
      container,
      'Silakan masuk atau daftar untuk melihat konten ini',
      'home-login-btn',
      onLoginClick
    );
  }

  renderStories(stories, container, append = false) {
    if (typeof container === 'string') {
      container = document.querySelector(container);
    }
    if (!container) return;

    if (!append) {
      container.innerHTML = '';
    }
    
    let storiesHtml = '';
    stories.forEach(story => {
      const timeAgo = formatTimeAgo(story.createdAt);
      const isBookmarked = story.isBookmarked || false;
      const locationParagraphId = `location-text-${story.id}`;
      const mapLocationNameId = `map-location-name-${story.id}`;
      
      storiesHtml += `
        <article class="postingan" data-story-id="${story.id}">
          <div class="post-user">
            <div class="user-sender">
              <div class="poster-photo">
                <img src="${getAvatarUrl(story.name)}" alt="Foto profil ${story.name}" width="48" height="48" loading="lazy">
              </div>
              <div class="sender-post">
                <h3>${story.name}</h3>
                ${story.lat && story.lon ? `
                  <button type="button" class="location-sender" aria-label="Lihat lokasi" data-text_tip="Lihat lokasi" data-hover_tip="right" data-dev_tip="desktop">
                    <span class="material-symbols-rounded" aria-hidden="true">location_on</span>
                    <p id="${locationParagraphId}">Memuat lokasi...</p>
                  </button>
                ` : ''}
              </div>
            </div>
            <div class="time-post">
              <p data-timestamp="${story.createdAt}">${timeAgo}</p>
            </div>
          </div>
          <div class="isi-postingan">
            <div class="post-text">${escapeHtml(story.description)}</div>
            ${story.photoUrl ? `
              <div class="post-image">
                <img src="${story.photoUrl}" alt="Story image" loading="lazy">
              </div>
            ` : ''}
          </div>
          ${story.lat && story.lon ? `
            <div class="location-view">
              <button type="button" class="box-mini-maps" aria-label="Lihat lokasi di peta" data-text_tip="Lihat lokasi di peta" data-hover_tip="top" data-dev_tip="desktop" onclick="app.navigateToPost('${story.id}')">
                <div class="info-maps">
                  <div class="mini-map">
                    <span class="material-symbols-rounded" aria-hidden="true">share_location</span>
                  </div>
                  <div class="nama-daerah">
                    <h4 id="${mapLocationNameId}">Memuat lokasi...</h4>
                    <p>lat: ${story.lat.toFixed(6)} · lon: ${story.lon.toFixed(6)}</p>
                  </div>
                </div>
                <div class="info-jarak">
                  <span class="view-location">Lihat lokasi</span>
                </div>
              </button>
            </div>
          ` : ''}
          <div class="action-post">
            <button class="bookmark-this ${isBookmarked ? 'bookmarked' : ''}" data-story-id="${story.id}" data-text_tip="${isBookmarked ? 'Hapus dari bookmark' : 'Tambah ke bookmark'}" data-hover_tip="top" data-dev_tip="desktop">
              <span class="material-symbols-rounded" aria-hidden="true">bookmark</span>
              <span>${isBookmarked ? 'Tersimpan' : 'Simpan'}</span>
            </button>
            <button class="share-this" data-story-id="${story.id}" data-text_tip="Bagikan cerita" data-hover_tip="top" data-dev_tip="desktop">
              <span class="material-symbols-rounded" aria-hidden="true">share</span>
              <span>Bagikan</span>
            </button>
          </div>
        </article>
      `;
    });
    
    container.insertAdjacentHTML('beforeend', storiesHtml);
  }

  updateLocationName(storyId, locationName) {
    const locationElements = document.querySelectorAll(`[data-story-id="${storyId}"] .location-sender p`);
    locationElements.forEach(el => {
      el.textContent = locationName;
    });
    
    const mapLocationElements = document.querySelectorAll(`[data-story-id="${storyId}"] .info-maps h4`);
    mapLocationElements.forEach(el => {
      el.textContent = locationName;
    });
  }

  updateBookmarkStatus(storyId, isBookmarked) {
    const buttons = document.querySelectorAll(`.bookmark-this[data-story-id="${storyId}"]`);
    buttons.forEach(btn => {
      if (isBookmarked) {
        btn.classList.add('bookmarked');
        btn.querySelector('span:last-child').textContent = 'Tersimpan';
        btn.setAttribute('data-text_tip', 'Hapus dari bookmark');
      } else {
        btn.classList.remove('bookmarked');
        btn.querySelector('span:last-child').textContent = 'Simpan';
        btn.setAttribute('data-text_tip', 'Tambah ke bookmark');
      }
    });
  }

  updatePostButtonState(canSubmit) {
    const submitBtn = document.querySelector('#submit-post');
    if (submitBtn) {
      submitBtn.disabled = !canSubmit;
      if (canSubmit) {
        submitBtn.style.opacity = '1';
        submitBtn.style.cursor = 'pointer';
      } else {
        submitBtn.style.opacity = '0.5';
        submitBtn.style.cursor = 'not-allowed';
      }
    }
  }

  setSubmitButtonLoading(isLoading) {
    const submitBtn = document.querySelector('#submit-post');
    if (!submitBtn) return;

    if (isLoading) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span class="material-symbols-rounded spin">progress_activity</span>';
    } else {
      submitBtn.disabled = false;
      submitBtn.innerHTML = `
        <p>Kirim</p>
        <span class="material-symbols-rounded" aria-hidden="true">send</span>
      `;
    }
  }

  clearForm() {
    const textarea = document.querySelector('#wysiwyg-post');
    if (textarea) textarea.value = '';
    
    const imagePreview = document.querySelector('#image-preview');
    if (imagePreview) imagePreview.classList.remove('show');
    
    const locationPreview = document.querySelector('#location-preview');
    if (locationPreview) locationPreview.classList.remove('show');
  }

  addImagePreview(src) {
    const imagePreviewImg = document.querySelector('#image-preview img');
    const imagePreviewContainer = document.querySelector('#image-preview');
    
    if (imagePreviewImg) {
      imagePreviewImg.src = src;
    }
    
    if (imagePreviewContainer) {
      imagePreviewContainer.classList.add('show');
    }
  }

  removeImagePreview() {
    const imagePreviewContainer = document.querySelector('#image-preview');
    if (imagePreviewContainer) {
      imagePreviewContainer.classList.remove('show');
    }
  }

  addLocationPreview(locationName, lat, lon) {
    const locationPreview = document.querySelector('#location-preview');
    const locationText = locationPreview?.querySelector('.nama-daerah p');
    
    if (locationText) {
      locationText.textContent = locationName;
    }
    
    if (locationPreview) {
      locationPreview.setAttribute('data-lat', lat);
      locationPreview.setAttribute('data-lon', lon);
      locationPreview.classList.add('show');
    }
  }

  removeLocationPreview() {
    const locationPreview = document.querySelector('#location-preview');
    if (locationPreview) {
      locationPreview.classList.remove('show');
      locationPreview.removeAttribute('data-lat');
      locationPreview.removeAttribute('data-lon');
    }
  }

  getFormDescription() {
    const textarea = document.querySelector('#wysiwyg-post');
    return textarea ? textarea.value.trim() : '';
  }

  renderNewPostsTab(count) {
    const newPostTab = document.querySelector('#new-post-tab');
    const newPostsCount = document.querySelector('#new-posts-count');
    const postFilter = document.querySelector('.post-filter');
    
    if (count >= 5) {
      if (newPostsCount) {
        newPostsCount.textContent = count > 9 ? '9+' : count;
      }
      
      const userPhotos = document.querySelectorAll('.user-post-recent .photos-recent img');
      userPhotos.forEach((img, index) => {
        if (index < 3) {
          img.src = `${getAvatarUrl(`User${index + 1}_${Date.now()}`)}`;
        }
      });
      
      if (postFilter) {
        postFilter.classList.add('full-wrap');
      }
      
      if (window.scrollY > 5 && newPostTab) {
        newPostTab.classList.remove('hide');
        newPostTab.classList.add('show');
      }
    } else {
      if (newPostTab) {
        newPostTab.classList.remove('show');
        newPostTab.classList.add('hide');
      }
      if (postFilter) {
        postFilter.classList.remove('full-wrap');
      }
    }
  }

  hideNewPostsTab() {
    const newPostTab = document.querySelector('#new-post-tab');
    if (newPostTab) {
      newPostTab.classList.remove('show', 'hide');
    }
    const postFilter = document.querySelector('.post-filter');
    if (postFilter) {
      postFilter.classList.remove('full-wrap');
    }
  }

  updateTimestamps() {
    document.querySelectorAll('.time-post p[data-timestamp]').forEach(element => {
      const timestamp = element.dataset.timestamp;
      if (timestamp) {
        element.textContent = formatTimeAgo(timestamp);
      }
    });
  }

  setFilterActive(filterType) {
    const allPostBtn = document.querySelector('#all-post');
    const mapsOnlyBtn = document.querySelector('#maps-only');
    
    if (filterType === 'maps') {
      if (allPostBtn) {
        allPostBtn.classList.remove('active');
        allPostBtn.setAttribute('aria-selected', 'false');
      }
      if (mapsOnlyBtn) {
        mapsOnlyBtn.classList.add('active');
        mapsOnlyBtn.setAttribute('aria-selected', 'true');
      }
    } else {
      if (mapsOnlyBtn) {
        mapsOnlyBtn.classList.remove('active');
        mapsOnlyBtn.setAttribute('aria-selected', 'false');
      }
      if (allPostBtn) {
        allPostBtn.classList.add('active');
        allPostBtn.setAttribute('aria-selected', 'true');
      }
    }
  }

  showLoadingMore(container) {
    if (typeof container === 'string') {
      container = document.querySelector(container);
    }
    
    const loadingIndicator = document.createElement('div');
    loadingIndicator.className = 'loading-more';
    loadingIndicator.style.textAlign = 'center';
    loadingIndicator.style.padding = '2rem';
    loadingIndicator.innerHTML = `
      <div class="hg-animate" style="width: 2rem; height: 2rem; margin: 0 auto;"></div>
      <p>Memuat lebih banyak...</p>
    `;
    
    if (container) {
      container.appendChild(loadingIndicator);
    }
    
    return loadingIndicator;
  }

  removeLoadingMore() {
    const loadingIndicator = document.querySelector('.loading-more');
    if (loadingIndicator) {
      loadingIndicator.remove();
    }
  }

  enableFlipCameraButton() {
    const flipButton = document.getElementById('flip-camera-btn');
    if (flipButton) {
      flipButton.style.display = '';
    }
  }

  disableFlipCameraButton() {
    const flipButton = document.getElementById('flip-camera-btn');
    if (flipButton) {
      flipButton.style.display = 'none';
    }
  }

  showCurrentLocationLoading() {
    const btn = document.querySelector('#current-location');
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = `
        <div class="hg-animate" style="width: 1rem; height: 1rem;" aria-hidden="true"></div>
        <span>Mencari lokasi...</span>
      `;
    }
  }

  hideCurrentLocationLoading() {
    const btn = document.querySelector('#current-location');
    if (btn) {
      btn.disabled = false;
      btn.innerHTML = `
        <span class="material-symbols-rounded" aria-hidden="true">my_location</span>
        <span>Gunakan Lokasi Saya</span>
      `;
    }
  }

  enableSaveLocationButton() {
    const saveBtn = document.querySelector('#save-location');
    if (saveBtn) {
      saveBtn.disabled = false;
    }
  }

  disableSaveLocationButton() {
    const saveBtn = document.querySelector('#save-location');
    if (saveBtn) {
      saveBtn.disabled = true;
    }
  }

  initializeLocationMap(config, selectedLocation, callbacks) {
    try {
      this.locationMap = new maplibregl.Map(config);
      this.locationMap.addControl(new maplibregl.NavigationControl(), 'top-right');

      const layerControl = this.createLocationMapLayerControl(callbacks.onLayerChange);
      this.locationMap.addControl(layerControl, 'top-left');
      
      this.locationMap.on('click', (e) => {
        const { lng, lat } = e.lngLat;
        this.addLocationMarker(lng, lat);
        callbacks.onMapClick(lat, lng);
      });

      if (selectedLocation) {
        this.addLocationMarker(selectedLocation.lon, selectedLocation.lat);
        this.setMapCenter(selectedLocation.lon, selectedLocation.lat, 15);
        this.enableSaveLocationButton();
      }

      return this.locationMap;
    } catch (error) {
      throw new Error('Gagal init lokasi map: ' + error.message);
    }
  }

  createLocationMapLayerControl(onLayerChange, selectedLayer = 'streets') {
    const view = this;
    
    class LayerControl {
      onAdd(map) {
        this._map = map;
        this._container = document.createElement('div');
        this._container.className = 'maplibregl-ctrl maplibregl-ctrl-group';
        
        const button = document.createElement('button');
        button.className = 'maplibregl-ctrl-icon';
        button.type = 'button';
        button.innerHTML = '<span class="material-symbols-rounded">layers</span>';
        button.title = 'Ubah layer peta';
        
        const dropdown = document.createElement('div');
        dropdown.className = 'layer-dropdown';
        dropdown.style.cssText = 'position: absolute; top: 100%; left: 0; background: var(--bg-container); border: 1px solid var(--border-color); border-radius: 4px; display: none; min-width: 120px; box-shadow: 0 2px 4px rgba(0,0,0,0.2);';
        
        const layers = [
          { name: 'Streets', value: 'streets' },
          { name: 'Satellite', value: 'satellite' },
          { name: 'Terrain', value: 'terrain' }
        ];

        layers.forEach(layer => {
          const item = document.createElement('div');
          item.textContent = layer.name;
          item.className = 'layer-list';
          item.dataset.layer = layer.value;
          item.style.cssText = 'padding: 8px 12px; cursor: pointer; color: var(--text-primary);';
          if (layer.value === selectedLayer) item.classList.add('active');
          item.addEventListener('click', () => {
            onLayerChange(layer.value);
            dropdown.style.display = 'none';
          });
          dropdown.appendChild(item);
          view.locationLayerItems.push(item);
        });
        
        button.addEventListener('click', (e) => {
          e.stopPropagation();
          dropdown.style.display = dropdown.style.display === 'none' ? 'block' : 'none';
        });
        
        document.addEventListener('click', () => {
          dropdown.style.display = 'none';
        });
        
        this._container.appendChild(button);
        this._container.appendChild(dropdown);
        return this._container;
      }
      
      onRemove() {
        if (this._container && this._container.parentNode) {
          this._container.parentNode.removeChild(this._container);
        }
        this._map = undefined;
      }
    }
    
    return new LayerControl();
  }

  updateMapStyle(styleUrl) {
    if (this.locationMap) {
      this.locationMap.setStyle(styleUrl);
    }
  }

  centerMapToLocation(lon, lat, zoom = 13) {
    if (this.locationMap) {
      this.locationMap.setCenter([lon, lat]);
      this.locationMap.setZoom(zoom);
    }
  }

  initializeLocationDialog(options) {
    const { mapConfig, selectedLocation, onMapClick, onLayerChange, selectedLayer = 'streets' } = options;
    
    try {
      this.locationMap = new maplibregl.Map(mapConfig);
      this.locationMap.addControl(new maplibregl.NavigationControl(), 'top-right');
  
      const layerControl = this.createLocationMapLayerControl(onLayerChange, selectedLayer);
      this.locationMap.addControl(layerControl, 'top-left');
      
      this.locationMap.on('click', (e) => {
        const { lng, lat } = e.lngLat;
        this.addLocationMarker(lng, lat);
        onMapClick(lat, lng);
      });
  
      if (selectedLocation) {
        this.addLocationMarker(selectedLocation.lon, selectedLocation.lat);
        this.setMapCenter(selectedLocation.lon, selectedLocation.lat, 15);
        this.enableSaveLocationButton();
      }
  
      return this.locationMap;
    } catch (error) {
      throw new Error('Gagal init location dialog: ' + error.message);
    }
  }

  cleanup() {
    this.cleanupEventListeners();
    this.cleanupPeriodicUpdates();
    
    if (this.cameraDialogObserver) {
      this.cameraDialogObserver.disconnect();
      this.cameraDialogObserver = null;
    }
    
    this.stopCameraStream();
    
    if (this.locationMarker) {
      this.locationMarker.remove();
      this.locationMarker = null;
    }
    
    if (this.locationMap) {
      this.locationMap.remove();
      this.locationMap = null;
    }
    
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }
    
    this.clearLocationResults();
  }
}